import { Button, MenuItem, Select, TextField } from '@mui/material'
import React from 'react'
import { useAdvancedSearchStore, userFieldValueIsUnsupported, userRecordsConditions } from '../hooks/useAdvancedSearch'
import useMembershipCategories from '../hooks/useMembershipCategories'

const UserRecordRow = ({ filterIndex, membershipTypes }) => {
    const filterRow = useAdvancedSearchStore(s => s.appliedUserRecords?.[filterIndex])
    const userRecords = useAdvancedSearchStore(s => s.userRecords)
    const modifyAppliedUserRecord = useAdvancedSearchStore(s => s.modifyAppliedUserRecord)
    const changeAddNewUserRecord = useAdvancedSearchStore(s => s.changeAddNewUserRecord)
    const [selectOptions, setSelectOptions] = React.useState([])

    const { field, condition, value, type } = filterRow || {}

    if (!filterRow) return <></>

    return (
        <div className='flex flex-1 [&>div]:w-[33.33%] mb-5 space-x-4'>
            {field !== undefined && <div className='flex'>
                <Select
                    fullWidth
                    value={field}
                    MenuProps={{
                        style: { zIndex: 35001 }
                    }}
                    onChange={(e) => {
                        modifyAppliedUserRecord(filterIndex, 'field', e.target.value)

                        modifyAppliedUserRecord(filterIndex, 'condition', "")
                        modifyAppliedUserRecord(filterIndex, 'value', undefined)

                        const child = userRecords.find((item) => item.value === e.target.value)
                        if (child) {
                            modifyAppliedUserRecord(filterIndex, 'type', child.type)
                            if (e.target.value === "partner_level") {
                                setSelectOptions(child.getOptions())
                            } else if (e.target.value === "member_type") {
                                setSelectOptions(child.getOptions(membershipTypes))
                            } else {
                                setSelectOptions([])
                            }
                        } else {
                            modifyAppliedUserRecord(filterIndex, 'type', "text")
                            setSelectOptions([])
                        }
                    }}
                >
                    {userRecords.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </div>}
            {condition !== undefined ? <div>
                <Select
                    fullWidth
                    value={condition}
                    MenuProps={{
                        style: { zIndex: 35001 }
                    }}
                    onChange={(e) => {
                        modifyAppliedUserRecord(filterIndex, 'condition', e.target.value)
                        modifyAppliedUserRecord(filterIndex, 'value', "")
                        changeAddNewUserRecord(true)
                    }}
                >
                    {userRecordsConditions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </div> : <div className='w-full' />}
            {(value !== undefined && !userFieldValueIsUnsupported(condition)) ? <div>
                {type === "text" && <TextField

                    fullWidth
                    value={value}
                    onChange={(e) => {
                        modifyAppliedUserRecord(filterIndex, 'value', e.target.value)
                    }}

                />}
                {type === "date" && <TextField
                    fullWidth
                    value={value}
                    type='date'
                    onChange={(e) => {
                        modifyAppliedUserRecord(filterIndex, 'value', e.target.value)
                    }}

                />}
                {type === "select" &&
                    <Select
                        fullWidth
                        value={value}
                        onChange={(e) => {
                            modifyAppliedUserRecord(filterIndex, 'value', e.target.value)
                        }}
                        MenuProps={{
                            style: { zIndex: 35001 }
                        }}
                    >
                        {selectOptions?.map?.((mc, index) => <MenuItem value={mc.value} key={index}>{mc.label}</MenuItem>)}
                    </Select>
                }
                {type === "boolean" &&
                    <Select
                        fullWidth
                        value={value}
                        onChange={(e) => {
                            modifyAppliedUserRecord(filterIndex, 'value', e.target.value)
                        }}
                        MenuProps={{
                            style: { zIndex: 35001 }
                        }}
                    >
                        <MenuItem value={1}>true</MenuItem>
                        <MenuItem value={0}>false</MenuItem>
                    </Select>
                }
            </div> : <div className='w-full' />}
        </div>
    )
}

function UserRecordsFilter() {
    const appliedUserRecordFilters = useAdvancedSearchStore(s => s.appliedUserRecords)
    const addNewAppliedUserRecord = useAdvancedSearchStore(s => s.addNewAppliedUserRecord)
    const canAddNewUserRecord = useAdvancedSearchStore(s => s.canAddNewUserRecord)

    const { membershipCategories } = useMembershipCategories()

    const membershipTypes = React.useMemo(() => {
        return Object.keys(membershipCategories || []).map(mt => ({ label: membershipCategories[mt].type, value: mt }))
    }, [membershipCategories])

    return (
        <div className='mx-[50px]'>
            <div className='flex flex-1 [&>div]:w-[33.33%] space-x-4'>
                <div>
                    <span>User Record</span>
                </div>
                <div>
                    <span>Condition</span>
                </div>
                <div>
                    <span>Filter</span>
                </div>
            </div>
            <div className='mt-5'>
                {
                    appliedUserRecordFilters.map((_, index) => (
                        <UserRecordRow key={index} filterIndex={index} membershipTypes={membershipTypes} />
                    ))
                }
            </div>
            <div className='mt-5'>
                <Button disabled={!canAddNewUserRecord} variant='contained' className='bg-secondary-500 hover:bg-secondary-500' onClick={addNewAppliedUserRecord}>
                    Add new filter
                </Button>
            </div>
        </div>
    )
}

export default UserRecordsFilter